/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-return-assign */
/* eslint-disable react/button-has-type */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
import { useCallback, useEffect, useRef, useState } from 'react';
import { GlobalWorkerOptions, getDocument } from 'pdfjs-dist';
import dayjs from 'dayjs';
import { Box, Typography } from '@mui/material';
import useAuthStore from '../../../store/auth';
import {
  getFileByIdRequest,
  getFileContentByIdRequest,
} from '../../../services';
import useCompanyStore from '../../../store/companies';
import useMeetingStore from '../../../store/meetings';
import { LoadingBackdrop } from '../../LoadingBackdrop';
import { useDebounce } from '../utils/useDebounce';
import { ModalPasswordFile } from '../../ModalPasswordFile';

GlobalWorkerOptions.workerSrc = '/pdf.worker.min.mjs';

interface PdfViewerProps {
  fileUrl: string;
  fileId: string;
  isEbook?: boolean;
  fileName?: string;
  isMinute?: boolean;
}

export default function PdfViewer({
  fileUrl = '',
  fileId = '',
  isEbook = false,
  fileName = '',
  isMinute = false,
}: PdfViewerProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  const [scale, setScale] = useState(1.0);
  const [isLoading, setIsLoading] = useState(false);
  const [isWrongPassword, setIsWrongPassword] = useState(false);
  const [passwordField, setPasswordField] = useState('');
  const [hasPassword, setHasPassword] = useState(false);
  const [pdf, setPdf] = useState<any>(null);
  const [numPages, setNumPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState('');
  const [fileUrlState, setFileUrlState] = useState('');
  const [fileIdState, setFileIdState] = useState('');

  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const debouncedToScroll = useDebounce(debouncedSearchTerm, 100);

  const selectedMeeting = useMeetingStore(state => state.selectedMeeting);
  const company = useCompanyStore(state => state.selectedCompany);
  const user = useAuthStore(state => state.user);

  const userOnCompany = company?.users?.find(u => u.id === user?.id);

  const loadPdf = useCallback(async () => {
    try {
      const loadingTask = getDocument(fileUrlState);
      if (!isEbook) {
        loadingTask.onPassword = (updateCallback: any, reason: any) => {
          setHasPassword(true);
          if (
            passwordField &&
            passwordField.length > 0 &&
            passwordField !== ''
          ) {
            updateCallback(passwordField);
            if (reason === 2) {
              loadingTask.destroy();
              setIsWrongPassword(true);
            } else {
              setIsWrongPassword(false);
              setHasPassword(false);
            }
          }
        };
      }
      const loadedPdf = await loadingTask.promise;
      setPdf(loadedPdf);
      setNumPages(loadedPdf.numPages);
    } catch (error: any) {
      if (error.message === 'Incorrect Password') {
        setIsWrongPassword(true);
      }
    }
  }, [fileUrlState, isEbook, passwordField]);

  useEffect(() => {
    const highlightText = async () => {
      if (!debouncedToScroll || !pdf || !containerRef.current) return;

      for (let pageNum = 1; pageNum <= numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const textContent = await page.getTextContent();
        const strings = textContent.items
          .map((item: any) => item.str)
          .join(' ');
        if (strings.toLowerCase().includes(debouncedToScroll.toLowerCase())) {
          const canvas =
            containerRef.current.querySelectorAll('canvas')[pageNum - 1];
          setTimeout(
            () =>
              canvas?.scrollIntoView({ behavior: 'smooth', block: 'center' }),
            300,
          );

          canvas?.classList.add('highlighted');
          setTimeout(() => canvas?.classList.remove('highlighted'), 2000);
          break;
        }
      }
    };

    highlightText();
  }, [debouncedToScroll]);

  const handleDownloadWithWaterMark = useCallback(async () => {
    try {
      setIsLoading(true);
      const responseGetFile = await getFileByIdRequest(
        fileId,
        company?.id as string,
        user?.id as string,
      );

      if (responseGetFile?.status === 200) {
        const responseToDownload = await getFileContentByIdRequest(
          fileId,
          user?.id as string,
          company?.id as string,
        );

        if (responseToDownload?.status === 200) {
          const url = responseToDownload?.data as string;
          const name = `${responseGetFile?.data?.original_name?.trim()}.pdf`;

          let a = document.createElement('a');
          document.body.appendChild(a);
          a.href = url;
          a.download = name;
          a.click();
          window.URL.revokeObjectURL(url);
        }
      }
    } catch (err) {
      console.log('Error WaterMark -> handleDownloadFile ', err);
    } finally {
      setIsLoading(false);
    }
  }, [company?.id, fileId, user?.id]);

  const handleDownloadEbookWithWaterMark = useCallback(async () => {
    setIsLoading(true);
    try {
      if (fileUrl) {
        const url = fileUrl;

        const name = `E-book ${selectedMeeting?.title?.trim()}.pdf`;

        let a = document.createElement('a');
        document.body.appendChild(a);
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } catch (err) {
      console.log('Error WaterMark -> handleDownloadEbookWithWaterMark ', err);
    } finally {
      setIsLoading(false);
    }
  }, [fileUrl, selectedMeeting?.title]);

  useEffect(() => {
    if (fileUrl !== '') {
      setFileUrlState(fileUrl);
    }
    if (fileId !== '') {
      setFileIdState(fileId);
    }
  }, [fileUrl, fileId]);

  useEffect(() => {
    if (fileUrlState !== '') {
      loadPdf();
    }
  }, [fileUrlState, passwordField]);

  useEffect(() => {
    const renderPages = async () => {
      if (!pdf || !containerRef.current) return;

      const container = containerRef.current;
      container.innerHTML = '';

      for (let pageNum = 1; pageNum <= numPages; pageNum++) {
        const page = await pdf.getPage(pageNum);
        const viewport = page.getViewport({ scale });

        const wrapper = document.createElement('div');
        wrapper.style.position = 'relative';
        wrapper.style.marginBottom = '16px';

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d')!;
        canvas.width = viewport.width;
        canvas.height = viewport.height;
        canvas.style.border = '1px solid #eee';
        canvas.style.display = 'block';
        canvas.style.marginLeft = 'auto';
        canvas.style.marginRight = 'auto';

        wrapper.appendChild(canvas);
        container.appendChild(wrapper);

        await page.render({ canvasContext: context, viewport }).promise;
        if (!isEbook) {
          const watermark = document.createElement('div');
          watermark.innerHTML = `<span style="display: flex; flex-direction: column; gap: 145px; justify-content: center; text-align: center;">
          <span style="display: flex; flex-direction: column; text-align: center;">
          <span style="color:#82868b; opacity: 0.15; font-size: 2rem; font-weight: bold;">${
            user?.doc
          }</span>
          <span style="color:#82868b; opacity: 0.15; font-size: 2rem; font-weight: bold;">${dayjs(
            new Date(),
          ).format('DD/MM/YYYY HH:mm')}</span>
          </span><span style="display: flex; flex-direction: column; text-align: center;"><span style="color:#82868b; opacity: 0.15; font-size: 2rem; font-weight: bold;">${
            user?.doc
          }</span><span style="color:#82868b; opacity: 0.15; font-size: 2rem; font-weight: bold;">${dayjs(
            new Date(),
          ).format(
            'DD/MM/YYYY HH:mm',
          )}</span></span><span style="display: flex; flex-direction: column; text-align: center;"><span style="color:#82868b; opacity: 0.15; font-size: 2rem; font-weight: bold;">${
            user?.doc
          }</span><span style="color:#82868b; opacity: 0.15; font-size: 2rem; font-weight: bold;">${dayjs(
            new Date(),
          ).format('DD/MM/YYYY HH:mm')}</span></span></span>`;
          Object.assign(watermark.style, {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%) rotate(-23deg)',
            fontSize: `${viewport.width / 10}px`,
            fontWeight: 'bold',
            color: 'rgba(253, 10, 10, 0.15)',
            pointerEvents: 'none',
            whiteSpace: 'nowrap',
            userSelect: 'none',
            zIndex: '99999999',
          });
          wrapper.appendChild(watermark);
        }

        if (debouncedSearchTerm) {
          const textContent = await page.getTextContent();
          const matches = textContent.items.filter((item: any) =>
            item.str.toLowerCase().includes(debouncedSearchTerm.toLowerCase()),
          );

          for (const item of matches) {
            const [a, b, c, d, e, f] = item.transform;
            const canvasRect = canvas.getBoundingClientRect();
            const wrapperRect = wrapper.getBoundingClientRect();
            const offsetX = (wrapper.offsetWidth - canvas.width) / 2;

            const highlight = document.createElement('div');
            Object.assign(highlight.style, {
              position: 'absolute',
              left: `${e * scale + offsetX}px`,
              top: `${viewport.height - f * scale - d * scale}px`,
              width: `${item.width * scale}px`,
              height: `${d * scale}px`,
              backgroundColor: 'rgba(255,255,0,0.4)',
              pointerEvents: 'none',
              borderRadius: '2px',
            });
            wrapper.appendChild(highlight);
          }
        }
      }
    };

    renderPages();
  }, [pdf, scale, numPages, debouncedSearchTerm, isEbook, user?.doc]);

  return (
    <div>
      {isLoading && (
        <LoadingBackdrop
          loading={isLoading}
          text="Baixando o arquivo..."
          component=""
        />
      )}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '5px',
          height: '40px',
          gap: '12px',
        }}
      >
        <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-start' }}>
          <input
            type="text"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            placeholder="Buscar no PDF"
            style={{
              padding: '5px 8px',
              borderRadius: '6px',
              border: '1px solid #ccc',
              outline: 'none',
              fontSize: '14px',
              width: '300px',
            }}
          />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            gap: '12px',
          }}
        >
          <button
            onClick={() => setScale(s => Math.max(s - 0.25, 0.75))}
            style={{
              backgroundColor: '#bfc3c6',
              color: '#ffffff',
              border: 'none',
              width: '25px',
              height: '25px',
              fontSize: '26px',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
            }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#999')}
            onMouseLeave={e =>
              (e.currentTarget.style.backgroundColor = '#adb5bd')
            }
            title="Zoom Out"
          >
            -
          </button>
          <button
            onClick={() => setScale(s => Math.min(s + 0.25, 3))}
            style={{
              backgroundColor: '#bfc3c6',
              color: '#ffffff',
              border: 'none',
              width: '25px',
              height: '25px',
              fontSize: '26px',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
            }}
            onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#999')}
            onMouseLeave={e =>
              (e.currentTarget.style.backgroundColor = '#adb5bd')
            }
            title="Zoom In"
          >
            +
          </button>
          <span
            style={{
              fontSize: '14px',
              alignSelf: 'center',
              color: '#f1f1f1',
              fontFamily: 'sans-serif',
              marginLeft: '12px',
            }}
          >
            {(scale * 100).toFixed(0)}%
          </span>
        </div>

        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '8px',
          }}
        >
          {!isEbook
            ? (userOnCompany?.profile === 'UN2' ||
                userOnCompany?.profile === 'UN1') && (
                <>
                  <a
                    href={fileUrl}
                    download
                    style={{
                      backgroundColor: '#adb5bd',
                      color: '#fff',
                      padding: '4px 12px',
                      borderRadius: '6px',
                      textDecoration: 'none',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      transition: 'background-color 0.3s',
                      whiteSpace: 'nowrap',
                    }}
                    onMouseEnter={e =>
                      (e.currentTarget.style.backgroundColor = '#888')
                    }
                    onMouseLeave={e =>
                      (e.currentTarget.style.backgroundColor = '#adb5bd')
                    }
                  >
                    ⬇ Download PDF (Sem marca d'água)
                  </a>
                  {(userOnCompany?.profile === 'UN1' ||
                    userOnCompany?.profile === 'UN2' ||
                    userOnCompany?.profile === 'UN3') && (
                    <button
                      onClick={handleDownloadWithWaterMark}
                      style={{
                        backgroundColor: '#adb5bd',
                        color: '#fff',
                        padding: '4px 12px',
                        borderRadius: '6px',
                        border: 'none',
                        minHeight: '29px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        transition: 'background-color 0.3s',
                        whiteSpace: 'nowrap',
                        cursor: 'pointer',
                      }}
                      onMouseEnter={e =>
                        (e.currentTarget.style.backgroundColor = '#888')
                      }
                      onMouseLeave={e =>
                        (e.currentTarget.style.backgroundColor = '#adb5bd')
                      }
                    >
                      ⬇ Download PDF (Com marca d'água)
                    </button>
                  )}
                </>
              )
            : (userOnCompany?.profile === 'UN1' ||
                userOnCompany?.profile === 'UN2' ||
                userOnCompany?.profile === 'UN3') && (
                <button
                  onClick={handleDownloadEbookWithWaterMark}
                  style={{
                    backgroundColor: '#adb5bd',
                    color: '#fff',
                    padding: '4px 12px',
                    borderRadius: '6px',
                    border: 'none',
                    minHeight: '29px',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    transition: 'background-color 0.3s',
                    whiteSpace: 'nowrap',
                    cursor: 'pointer',
                  }}
                  onMouseEnter={e =>
                    (e.currentTarget.style.backgroundColor = '#888')
                  }
                  onMouseLeave={e =>
                    (e.currentTarget.style.backgroundColor = '#adb5bd')
                  }
                >
                  ⬇ Download Ebook (Com marca d'água)
                </button>
              )}
        </div>
      </div>

      {hasPassword && (
        <ModalPasswordFile
          btnTextConfirm="Abrir"
          onConfirm={password => setPasswordField(password)}
          open={hasPassword}
          title="Insira a senha do documento"
          isWrongPassword={isWrongPassword}
          onCancel={() => {
            setHasPassword(false);
            setIsWrongPassword(true);
            setPasswordField('');
          }}
        />
      )}
      {isWrongPassword ? (
        <Box
          sx={{
            textAlign: 'center',
            height: '80vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography sx={{ color: '#fff' }}>
            Senha do documento incorreta.
          </Typography>
        </Box>
      ) : (
        <div
          ref={containerRef}
          style={{
            height: '80vh',
            overflowY: 'auto',
            padding: '8px',
            border: '1px solid #444',
            borderRadius: '8px',
            scrollbarWidth: 'thin', // Firefox
            scrollbarColor: '#ccc transparent', // Firefox
          }}
          className="custom-scroll"
        />
      )}
    </div>
  );
}
